import { useUser } from '../../../../../redux/reducer/user';

export default function useGetMyPrizes() {
  const {
    profile: { prizes },
  } = useUser();

  return prizes?.filter?.(({ type }) => type === 'Material');
}
